<template>
  <div id="box">
    <div class="historyTag">
      <historyTag :historyArr="historyArr"></historyTag>
    </div>

    <p class="hint">
      预约寄件全量列表。待取件可「取消并退运费」；快递100已取消但本地未退的可用「补退运费」。也可筛选申诉待处理等情况。
    </p>

    <div class="toolbar">
      <el-input
        v-model="filters.keyword"
        placeholder="寄件单号/订单号/父单号/运单号/ID"
        clearable
        size="small"
        style="width: 260px; margin-right: 8px"
        @keyup.enter.native="search"
      />
      <el-select
        v-model="filters.status"
        clearable
        placeholder="状态"
        size="small"
        style="width: 130px; margin-right: 8px"
      >
        <el-option v-for="o in statusOptions" :key="o.value" :label="o.label" :value="o.value" />
      </el-select>
      <el-select
        v-model="filters.bizType"
        clearable
        placeholder="业务类型"
        size="small"
        style="width: 140px; margin-right: 8px"
      >
        <el-option v-for="o in bizTypeOptions" :key="o.value" :label="o.label" :value="o.value" />
      </el-select>
      <el-select
        v-model="filters.freightPayMode"
        clearable
        placeholder="运费模式"
        size="small"
        style="width: 120px; margin-right: 8px"
      >
        <el-option label="预付 PREPAY" value="PREPAY" />
        <el-option label="揽收后付" value="POST_PICK" />
      </el-select>
      <el-select
        v-model="filters.specialCase"
        clearable
        placeholder="特殊情况"
        size="small"
        style="width: 180px; margin-right: 8px"
      >
        <el-option label="已取消待补退运费" value="needCancelFreightRetry" />
        <el-option label="退货运费申诉待处理" value="freightAppealPending" />
      </el-select>
      <el-button type="primary" size="small" @click="search">查询</el-button>
      <el-button size="small" @click="resetSearch">重置</el-button>
    </div>

    <div class="table-scroll-wrap">
      <el-table :data="tableData" border style="width: 100%; margin-top: 12px" v-loading="loading">
        <el-table-column prop="kuaidinum" label="运单号" min-width="140" align="center" show-overflow-tooltip />
        <el-table-column label="关联单号" min-width="190" align="center" show-overflow-tooltip>
          <template slot-scope="scope">
            <div class="order-cell">
              <div v-if="scope.row.fatherOrderNo">父单：{{ scope.row.fatherOrderNo }}</div>
              <div
                v-if="scope.row.secondhandOrderNo && scope.row.secondhandOrderNo !== scope.row.fatherOrderNo"
              >
                {{ scope.row.fatherOrderNo ? "子单：" : "" }}{{ scope.row.secondhandOrderNo }}
              </div>
              <span v-if="!scope.row.fatherOrderNo && !scope.row.secondhandOrderNo">-</span>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="用户信息" min-width="180" align="center" show-overflow-tooltip>
          <template slot-scope="scope">
            <div class="user-cell">
              <div>昵称：{{ userNick(scope.row) }}</div>
              <div>会员号：{{ userScentId(scope.row) }}</div>
              <div>寄件人：{{ userSendManName(scope.row) }}</div>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="业务" width="100" align="center">
          <template slot-scope="scope">{{ bizTypeLabel(scope.row.bizType) }}</template>
        </el-table-column>
        <el-table-column label="状态" width="100" align="center">
          <template slot-scope="scope">
            <el-tag size="mini" :type="statusTagType(scope.row.status)">{{ statusLabel(scope.row.status) }}</el-tag>
          </template>
        </el-table-column>
        <el-table-column label="快递" min-width="110" align="center" show-overflow-tooltip>
          <template slot-scope="scope">
            {{ scope.row.kuaidicomName || scope.row.kuaidicom || "-" }}
          </template>
        </el-table-column>
        <el-table-column label="运费模式" width="90" align="center">
          <template slot-scope="scope">{{ freightModeLabel(scope.row.freightPayMode) }}</template>
        </el-table-column>
        <el-table-column label="已付运费" width="90" align="center">
          <template slot-scope="scope">{{ formatMoney(scope.row.payAmount) }}</template>
        </el-table-column>
        <el-table-column label="运费退款" width="120" align="center">
          <template slot-scope="scope">
            <el-tag
              v-if="scope.row.freightRefundDisplay === 'PENDING_RETRY'"
              size="mini"
              type="warning"
            >待补退</el-tag>
            <el-tag
              v-else-if="scope.row.freightRefundDisplay === 'REFUNDED'"
              size="mini"
              type="success"
            >已退</el-tag>
            <span v-else>{{ scope.row.freightRefundHint || "-" }}</span>
          </template>
        </el-table-column>
        <el-table-column label="退运费时间" width="160" align="center">
          <template slot-scope="scope">{{ formatTime(scope.row.freightRefundTime) }}</template>
        </el-table-column>
        <el-table-column label="申诉" width="90" align="center">
          <template slot-scope="scope">{{ appealLabel(scope.row.freightAppealStatus) }}</template>
        </el-table-column>
        <el-table-column label="创建时间" width="160" align="center">
          <template slot-scope="scope">{{ formatTime(scope.row.createTime) }}</template>
        </el-table-column>
        <el-table-column label="操作" width="340" align="center" fixed="right">
          <template slot-scope="scope">
            <el-button type="text" size="mini" @click="openDetail(scope.row)">详情</el-button>
            <el-button
              v-if="scope.row.canMgmtCancelAndRefund"
              type="danger"
              size="mini"
              plain
              @click="cancelAndRefund(scope.row)"
            >取消并退运费</el-button>
            <el-button
              v-if="scope.row.canRetryCancelFreightRefund"
              type="warning"
              size="mini"
              plain
              @click="retryCancelRefund(scope.row)"
            >补退运费</el-button>
            <el-button
              v-if="scope.row.canHandleFreightAppeal"
              type="success"
              size="mini"
              @click="approveAppeal(scope.row)"
            >同意申诉</el-button>
            <el-button
              v-if="scope.row.canHandleFreightAppeal"
              type="danger"
              size="mini"
              plain
              @click="rejectAppeal(scope.row)"
            >驳回</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>

    <list-pagination
      :total="tableTotal"
      :current-page.sync="currentPage"
      :page-size.sync="pageSize"
      @page-change="changePage"
      @size-change="handlePageSizeChange"
    />

    <el-dialog title="寄件单详情" :visible.sync="detailVisible" width="720px" append-to-body>
      <div v-if="detailRow" class="detail-grid" v-loading="detailLoading">
        <div class="detail-item"><span class="k">寄件单ID</span><span>{{ detailRow.id }}</span></div>
        <div class="detail-item"><span class="k">寄件单号</span><span>{{ detailRow.pickupNo || "-" }}</span></div>
        <div class="detail-item"><span class="k">二手订单号</span><span>{{ detailRow.secondhandOrderNo || "-" }}</span></div>
        <div class="detail-item"><span class="k">父订单号</span><span>{{ detailRow.fatherOrderNo || "-" }}</span></div>
        <div class="detail-item"><span class="k">业务类型</span><span>{{ bizTypeLabel(detailRow.bizType) }}</span></div>
        <div class="detail-item"><span class="k">状态</span><span>{{ statusLabel(detailRow.status) }}</span></div>
        <div class="detail-item"><span class="k">快递状态</span><span>{{ detailRow.kuaidiStatus != null ? detailRow.kuaidiStatus : "-" }}</span></div>
        <div class="detail-item"><span class="k">支付状态</span><span>{{ detailRow.payStatus || "-" }}</span></div>
        <div class="detail-item"><span class="k">运费模式</span><span>{{ freightModeLabel(detailRow.freightPayMode) }}</span></div>
        <div class="detail-item"><span class="k">预估运费</span><span>{{ formatMoney(detailRow.estimatedFreight) }}</span></div>
        <div class="detail-item"><span class="k">已付运费</span><span>{{ formatMoney(detailRow.payAmount) }}</span></div>
        <div class="detail-item"><span class="k">实际运费</span><span>{{ formatMoney(detailRow.actualFreight) }}</span></div>
        <div class="detail-item"><span class="k">支付时间</span><span>{{ formatTime(detailRow.payTime) }}</span></div>
        <div class="detail-item"><span class="k">退运费时间</span><span>{{ formatTime(detailRow.freightRefundTime) }}</span></div>
        <div class="detail-item"><span class="k">快递公司</span><span>{{ detailRow.kuaidicomName || detailRow.kuaidicom || "-" }}</span></div>
        <div class="detail-item"><span class="k">运单号</span><span>{{ detailRow.kuaidinum || "-" }}</span></div>
        <div class="detail-item"><span class="k">快递员</span><span>{{ detailRow.courierName || "-" }} {{ detailRow.courierMobile || "" }}</span></div>
        <div class="detail-item"><span class="k">昵称</span><span>{{ userNick(detailRow) }}</span></div>
        <div class="detail-item"><span class="k">会员号</span><span>{{ userScentId(detailRow) }}</span></div>
        <div class="detail-item"><span class="k">寄件人</span><span>{{ userSendManName(detailRow) }}</span></div>
        <div class="detail-item"><span class="k">退款申请ID</span><span>{{ detailRow.refundApplyId || "-" }}</span></div>
        <div class="detail-item"><span class="k">卖家结算</span><span>{{ detailRow.sellerSettleStatus || "-" }}</span></div>
        <div class="detail-item"><span class="k">申诉状态</span><span>{{ appealLabel(detailRow.freightAppealStatus) }}</span></div>
        <div class="detail-item full"><span class="k">申诉说明</span><span>{{ detailRow.freightAppealReason || "-" }}</span></div>
        <div class="detail-item full"><span class="k">寄件人</span><span>{{ detailRow.sendManName || "-" }} {{ detailRow.sendManMobile || "" }}</span></div>
        <div class="detail-item full"><span class="k">取件地址</span><span>{{ detailRow.sendManAddr || "-" }}</span></div>
        <div class="detail-item full">
          <span class="k">取件时间</span>
          <span>
            {{ detailRow.dayType || "" }}
            {{ detailRow.pickupStartTime || "" }}{{ detailRow.pickupStartTime && detailRow.pickupEndTime ? "-" : "" }}{{ detailRow.pickupEndTime || "" }}
            <template v-if="!detailRow.dayType && !detailRow.pickupStartTime">-</template>
          </span>
        </div>
        <div class="detail-item full"><span class="k">取消原因</span><span>{{ detailRow.cancelMsg || "-" }}</span></div>
        <div class="detail-item"><span class="k">创建时间</span><span>{{ formatTime(detailRow.createTime) }}</span></div>
        <div class="detail-item"><span class="k">更新时间</span><span>{{ formatTime(detailRow.updateTime) }}</span></div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button
          v-if="detailRow && detailRow.canMgmtCancelAndRefund"
          type="danger"
          size="small"
          @click="cancelAndRefund(detailRow)"
        >取消并退运费</el-button>
        <el-button
          v-if="detailRow && detailRow.canRetryCancelFreightRefund"
          type="warning"
          size="small"
          @click="retryCancelRefund(detailRow)"
        >补退运费</el-button>
        <el-button size="small" @click="detailVisible = false">关闭</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { returnTime, decodeUnicodeEscapes } from "@/util/utils";

const STATUS_OPTIONS = [
  { value: "ORDERED", label: "待取件" },
  { value: "PICKED", label: "已揽收" },
  { value: "WAIT_PAY", label: "待付运费" },
  { value: "PAID", label: "已付运费" },
  { value: "SETTLED", label: "已结算" },
  { value: "CANCELLED", label: "已取消" },
  { value: "FAILED", label: "失败" },
];

const BIZ_TYPE_OPTIONS = [
  { value: "JB_SHIP", label: "鉴别寄件" },
  { value: "JS_SHIP", label: "寄售寄件" },
  { value: "SELLER_SHIP", label: "卖家发货" },
  { value: "BUYER_RETURN", label: "买家退货" },
];

export default {
  name: "SecondhandPickupOrderMgmt",
  data() {
    return {
      historyArr: ["订单管理", "预约寄件订单"],
      loading: false,
      tableData: [],
      tableTotal: 0,
      currentPage: 1,
      pageSize: 20,
      filters: {
        keyword: "",
        status: "",
        bizType: "",
        freightPayMode: "",
        specialCase: "",
      },
      statusOptions: STATUS_OPTIONS,
      bizTypeOptions: BIZ_TYPE_OPTIONS,
      detailVisible: false,
      detailLoading: false,
      detailRow: null,
    };
  },
  mounted() {
    this.fetchList(1);
  },
  methods: {
    statusLabel(v) {
      const hit = STATUS_OPTIONS.find((o) => o.value === v);
      return hit ? hit.label : v || "-";
    },
    statusTagType(v) {
      if (v === "CANCELLED" || v === "FAILED") return "info";
      if (v === "ORDERED") return "warning";
      if (v === "PAID" || v === "SETTLED") return "success";
      return "";
    },
    bizTypeLabel(v) {
      const hit = BIZ_TYPE_OPTIONS.find((o) => o.value === v);
      return hit ? hit.label : v || "-";
    },
    freightModeLabel(v) {
      if (v === "PREPAY") return "预付";
      if (v === "POST_PICK") return "揽收后付";
      return v || "-";
    },
    appealLabel(v) {
      const map = {
        NONE: "-",
        CAN_APPEAL: "可申诉",
        PENDING: "待处理",
        APPROVED: "已同意",
        REJECTED: "已驳回",
        REFUNDED: "已退款",
      };
      return map[v] || v || "-";
    },
    userNick(row) {
      if (!row) return "-";
      const raw = row.sellerNickName || row.buyerNickName || "";
      const nick = raw ? decodeUnicodeEscapes(String(raw).trim()) : "";
      return nick || "-";
    },
    userScentId(row) {
      if (!row) return "-";
      const scent = row.sellerScentId || row.buyerScentId || "";
      return scent ? String(scent).trim() : "-";
    },
    userSendManName(row) {
      if (!row || !row.sendManName) return "-";
      const name = decodeUnicodeEscapes(String(row.sendManName).trim());
      return name || "-";
    },
    formatMoney(v) {
      if (v == null || v === "") return "-";
      const n = Number(v);
      return Number.isFinite(n) ? n.toFixed(2) : String(v);
    },
    formatTime(t) {
      if (!t) return "-";
      try {
        return returnTime(t, "-", "s");
      } catch (e) {
        return String(t);
      }
    },
    search() {
      this.fetchList(1);
    },
    resetSearch() {
      this.filters = {
        keyword: "",
        status: "",
        bizType: "",
        freightPayMode: "",
        specialCase: "",
      };
      this.fetchList(1);
    },
    changePage(p) {
      this.currentPage = p;
      this.fetchList(p);
    },
    handlePageSizeChange() {
      this.fetchList(1);
    },
    buildListUrl(page) {
      const q = [
        `page=${page || 1}`,
        `size=${this.pageSize}`,
      ];
      const f = this.filters || {};
      if (f.keyword) q.push(`keyword=${encodeURIComponent(f.keyword.trim())}`);
      if (f.status) q.push(`status=${encodeURIComponent(f.status)}`);
      if (f.bizType) q.push(`bizType=${encodeURIComponent(f.bizType)}`);
      if (f.freightPayMode) q.push(`freightPayMode=${encodeURIComponent(f.freightPayMode)}`);
      if (f.specialCase) q.push(`specialCase=${encodeURIComponent(f.specialCase)}`);
      return `${this.$api.api.mgmtPickupOrderList}?${q.join("&")}`;
    },
    fetchList(page) {
      this.loading = true;
      const p = page || 1;
      this.currentPage = p;
      this.$https(this.buildListUrl(p), {}, "GET")
        .then((res) => {
          if (res.data && res.data.code == 200) {
            this.tableData = res.data.data || [];
            this.tableTotal = res.data.size || 0;
          } else {
            this.tableData = [];
            this.tableTotal = 0;
            this.$message.error((res.data && res.data.msg) || "查询失败");
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },
    openDetail(row) {
      if (!row || !row.id) return;
      this.detailVisible = true;
      this.detailRow = { ...row };
      this.detailLoading = true;
      const url = `${this.$api.api.mgmtPickupOrderDetail}?pickupOrderId=${encodeURIComponent(row.id)}`;
      this.$https(url, {}, "GET")
        .then((res) => {
          if (res.data && res.data.code == 200 && res.data.data) {
            this.detailRow = res.data.data;
          }
        })
        .finally(() => {
          this.detailLoading = false;
        });
    },
    cancelAndRefund(row) {
      if (!row || !row.id) return;
      const amt =
        row.payAmount != null && row.payAmount !== ""
          ? Number(row.payAmount).toFixed(2)
          : null;
      const amtTip = amt != null && Number.isFinite(Number(amt)) ? `（约 ¥${amt}）` : "";
      this.$prompt(
        `确认取消寄件单 ${row.pickupNo || row.id} 并原路退回预付运费${amtTip}？\n若快递100侧已取消，仍会同步本地并退运费。可填写取消原因：`,
        "取消寄件并退运费",
        {
          confirmButtonText: "确认取消并退运费",
          cancelButtonText: "取消",
          inputPlaceholder: "取消原因",
          inputValue: "运营取消寄件并退运费",
          type: "warning",
        }
      )
        .then(({ value }) => {
          const cancelMsg = value != null ? String(value).trim() : "";
          let url = `${this.$api.api.mgmtPickupCancelAndRefund}?pickupOrderId=${encodeURIComponent(row.id)}`;
          if (cancelMsg) {
            url += `&cancelMsg=${encodeURIComponent(cancelMsg)}`;
          }
          return this.$https(url, {}, "POST");
        })
        .then((res) => {
          if (res.data && res.data.code == 200) {
            this.$message.success((res.data && res.data.msg) || "已取消并退运费");
            this.detailVisible = false;
            this.fetchList(this.currentPage);
          } else {
            this.$message.error((res.data && res.data.msg) || "操作失败");
          }
        })
        .catch(() => {});
    },
    retryCancelRefund(row) {
      if (!row || !row.id) return;
      this.$confirm(
        `确认对寄件单 ${row.pickupNo || row.id} 补退预付运费？将按幂等原路退回。`,
        "补退运费",
        { type: "warning" }
      )
        .then(() => {
          const url = `${this.$api.api.mgmtPickupCancelFreightRetry}?pickupOrderId=${encodeURIComponent(row.id)}`;
          return this.$https(url, {}, "POST");
        })
        .then((res) => {
          if (res.data && res.data.code == 200) {
            this.$message.success((res.data && res.data.msg) || "补退成功");
            this.detailVisible = false;
            this.fetchList(this.currentPage);
          } else {
            this.$message.error((res.data && res.data.msg) || "补退失败");
          }
        })
        .catch(() => {});
    },
    approveAppeal(row) {
      if (!row || !row.id) return;
      this.$confirm("确认同意申诉并原路退回该笔退货运费？", "同意申诉退运费", {
        type: "warning",
      })
        .then(() => {
          const url = `${this.$api.api.mgmtPickupFreightAppealApprove}?pickupOrderId=${encodeURIComponent(row.id)}`;
          return this.$https(url, {}, "POST");
        })
        .then((res) => {
          if (res.data && res.data.code == 200) {
            this.$message.success("已原路退回运费");
            this.fetchList(this.currentPage);
          } else {
            this.$message.error((res.data && res.data.msg) || "操作失败");
          }
        })
        .catch(() => {});
    },
    rejectAppeal(row) {
      if (!row || !row.id) return;
      this.$prompt("请填写驳回说明（可选）", "驳回申诉", {
        confirmButtonText: "驳回",
        cancelButtonText: "取消",
        inputPlaceholder: "驳回原因",
      })
        .then(({ value }) => {
          const reason = value != null ? String(value).trim() : "";
          let url = `${this.$api.api.mgmtPickupFreightAppealReject}?pickupOrderId=${encodeURIComponent(row.id)}`;
          if (reason) {
            url += `&rejectReason=${encodeURIComponent(reason)}`;
          }
          return this.$https(url, {}, "POST");
        })
        .then((res) => {
          if (res.data && res.data.code == 200) {
            this.$message.success("已驳回");
            this.fetchList(this.currentPage);
          } else {
            this.$message.error((res.data && res.data.msg) || "操作失败");
          }
        })
        .catch(() => {});
    },
  },
};
</script>

<style scoped>
.hint {
  margin: 8px 0 0;
  font-size: 13px;
  color: #666;
  line-height: 1.5;
}
.toolbar {
  margin-top: 12px;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
}
.detail-grid {
  display: flex;
  flex-wrap: wrap;
  margin: -6px;
}
.detail-item {
  width: 50%;
  box-sizing: border-box;
  padding: 6px;
  font-size: 13px;
  line-height: 1.5;
  color: #333;
}
.detail-item.full {
  width: 100%;
}
.detail-item .k {
  display: inline-block;
  min-width: 88px;
  color: #888;
  margin-right: 8px;
}
.user-cell {
  text-align: left;
  line-height: 1.45;
  font-size: 12px;
}
.order-cell {
  text-align: left;
  line-height: 1.45;
  font-size: 12px;
}
</style>



// WEBPACK FOOTER //
// src/pages/secondhandPickupOrder/index.vue